import * as i0 from "@angular/core";
var DataService = /** @class */ (function () {
    function DataService() {
    }
    DataService.ngInjectableDef = i0.defineInjectable({ factory: function DataService_Factory() { return new DataService(); }, token: DataService, providedIn: "root" });
    return DataService;
}());
export { DataService };
